import { useState, useEffect } from 'react';

export function useSession(sessionId) {
  const [session, setSession] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateSession = async () => {
    if (!sessionId) return;
    
    try {
      setIsLoading(true);
      // TODO: Implement actual API call
      console.log('Fetching session:', sessionId);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Mock session data
      const mockSession = {
        id: sessionId,
        title: 'Sample Session',
        config: {
          subject: 'Shabbat',
          age: '8-10',
          level: 'beginner'
        },
        sequences: [
          {
            id: 'seq_1',
            title: 'Introduction',
            blocks: [
              {
                id: 'block_1',
                type: 'image',
                content: {
                  images: [
                    { url: 'https://via.placeholder.com/300x200' },
                    { url: 'https://via.placeholder.com/300x200' },
                    { url: 'https://via.placeholder.com/300x200' }
                  ]
                }
              },
              {
                id: 'block_2',
                type: 'teacher_notes',
                layers: [
                  {
                    id: 'explanation',
                    title: 'Simple Explanation',
                    content: {
                      text: 'This is a sample explanation for children.',
                      char_count: 50
                    },
                    char_limit: 500
                  },
                  {
                    id: 'did_you_know',
                    title: 'Did you know?',
                    content: {
                      text: 'Did you know that this is a sample fact?',
                      char_count: 45
                    },
                    char_limit: 300
                  }
                ]
              },
              {
                id: 'block_3',
                type: 'quiz',
                quiz_type: 'mcq',
                content: {
                  question: {
                    text: 'What is the main topic of this session?',
                    char_count: 45
                  },
                  answers: [
                    {
                      id: 'ans_1',
                      text: 'Shabbat',
                      is_correct: true,
                      explanation: 'Correct!',
                      char_count: 7
                    },
                    {
                      id: 'ans_2',
                      text: 'Hanukkah',
                      is_correct: false,
                      explanation: 'Not quite.',
                      char_count: 8
                    },
                    {
                      id: 'ans_3',
                      text: 'Passover',
                      is_correct: false,
                      explanation: 'Try again.',
                      char_count: 8
                    },
                    {
                      id: 'ans_4',
                      text: 'Rosh Hashanah',
                      is_correct: false,
                      explanation: 'Not this time.',
                      char_count: 12
                    }
                  ]
                }
              }
            ]
          }
        ]
      };
      
      setSession(mockSession);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateSession();
  }, [sessionId]);

  return { session, isLoading, error, updateSession };
}
